import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import UIIcon from 'UIComponents/icon/UIIcon';
import { GreyContainer, LargeWrapper, PopoverHeader } from './SharedStyleComponents';
import { useRandomContentAssistanceTip } from './useRandomContentAssistanceTipsAndQuips';
import UIImage from 'UIComponents/image/UIImage';
// @ts-expect-error Untyped module
import loadingRobotGif from 'bender-url!content-assistance-lib/img/loading_robot.gif';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const GreyContainerTips = styled(GreyContainer).withConfig({
  displayName: "ContentAssistantLoadingScreen__GreyContainerTips",
  componentId: "m0sxv4-0"
})(["font-weight:400;font-size:14px;justify-content:flex-start;margin-top:auto;"]);
const ImageContainer = styled.div.withConfig({
  displayName: "ContentAssistantLoadingScreen__ImageContainer",
  componentId: "m0sxv4-1"
})(["flex:1;display:flex;justify-items:center;align-items:flex-end;padding-bottom:10px;"]);
export default function ContentAssistantLoadingScreen({
  body,
  label,
  onCancel,
  tips
}) {
  const randomTipKey = useRandomContentAssistanceTip(tips);
  return /*#__PURE__*/_jsxs(LargeWrapper, {
    "data-loading": true,
    children: [/*#__PURE__*/_jsx(PopoverHeader, {
      label: label,
      onCancel: onCancel,
      body: body
    }), /*#__PURE__*/_jsx(ImageContainer, {
      children: /*#__PURE__*/_jsx(UIImage, {
        alt: I18n.text('baseContentGenerationModal.generatingContent'),
        src: loadingRobotGif,
        style: {
          maxHeight: 120
        }
      })
    }), /*#__PURE__*/_jsxs(GreyContainerTips, {
      children: [/*#__PURE__*/_jsx(UIIcon, {
        name: "bulb",
        className: "m-right-1"
      }), /*#__PURE__*/_jsxs("span", {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "tips.tip"
        }), ":", ' ', /*#__PURE__*/_jsx(FormattedMessage, {
          message: randomTipKey
        })]
      })]
    })]
  });
}